import callsService from '@/services/callsService'

const state = {
  administratorCallConfig: {},
  administratorCalls: [],
  appCalls: [],
  personCalls: []
}

const mutations = {
  SET_ADMINISTRATOR_CALL_CONFIG (state, administratorCallConfig) {
    state.administratorCallConfig = administratorCallConfig
  },
  SET_ADMINISTRATOR_CALLS (state, administratorCalls) {
    state.administratorCalls = administratorCalls
  },
  SET_APP_CALLS (state, appCalls) {
    state.appCalls = appCalls
  },
  SET_PERSON_CALLS (state, personCalls) {
    state.personCalls = personCalls
  }
}

const actions = {
  async callPerson (vuexContext, { companyId, appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    const company = companyId || vuexContext.getters.companyId
    await callsService.callPerson(vuexContext.getters.token, company, app, data)
  },
  async getAdministratorCallConfig (vuexContext, { companyId, administratorId }) {
    try {
      const company = companyId || vuexContext.getters.companyUuid
      const response = await callsService.getAdministratorCallConfig(
        vuexContext.getters.token,
        company,
        administratorId
      )
      vuexContext.commit('SET_ADMINISTRATOR_CALL_CONFIG', response)
    } catch (e) {
      vuexContext.commit('SET_ADMINISTRATOR_CALL_CONFIG', {})
    }
  },
  async getAdministratorCalls (vuexContext, { companyId, appId, data }) {
    try {
      const response = await vuexContext.dispatch(
        'getAppCalls',
        { companyId, appId, data, getAppCalls: false }
      )
      vuexContext.commit('SET_ADMINISTRATOR_CALLS', response.rows)
    } catch (e) {
      vuexContext.commit('SET_ADMINISTRATOR_CALLS', [])
    }
  },
  async getAppCalls (vuexContext, { companyId, appId, data, getAppCalls = true }) {
    try {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      const response = await callsService.getAppCalls(
        vuexContext.getters.token,
        company,
        app,
        data
      )
      if (getAppCalls) {
        vuexContext.commit('SET_APP_CALLS', response.rows)
      } else {
        return response
      }
    } catch (e) {
      if (getAppCalls) {
        vuexContext.commit('SET_APP_CALLS', [])
      }
    }
  },
  async getPersonCalls (vuexContext, { companyId, appId, data }) {
    try {
      const response = await vuexContext.dispatch(
        'getAppCalls',
        { companyId, appId, data, getAppCalls: false }
      )
      vuexContext.commit('SET_PERSON_CALLS', response.rows)
    } catch (e) {
      vuexContext.commit('SET_PERSON_CALLS', [])
    }
  },
  async updateAdministratorCallConfig (vuexContext, { companyId, administratorId, data }) {
    await callsService.updateAdministratorCallConfig(
      vuexContext.getters.token,
      companyId,
      administratorId,
      data
    )
  }
}

const getters = {
  administratorCallConfig (state) {
    const adminCallConfig = {
      clientId: '',
      userEmail: '',
      password: ''
    }
    if (!state.administratorCallConfig ||
        !Array.isArray(state.administratorCallConfig) ||
        !state.administratorCallConfig.length) {
      return adminCallConfig
    }
    for (const item of state.administratorCallConfig) {
      if (item.field === 'CALL_CLIENTID') adminCallConfig.clientId = item.value
      else if (item.field === 'CALL_USEREMAIL') adminCallConfig.userEmail = item.value
    }
    return adminCallConfig
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
